module.exports = __webpack_public_path__ + "img/5_94.e89f5dfa.png";